module.exports = __webpack_public_path__ + "static/media/menu.38acbf86.svg";